import a from "react";
import { clsx as b } from "../../../clsx/dist/clsx.js";
import { useChartWidth as h, useChartHeight as v, useXAxisOrThrow as d } from "../context/chartLayoutContext.js";
import { CartesianAxis as O } from "./CartesianAxis.js";
import { getTicksOfAxis as _ } from "../util/ChartUtils.js";
function i(e) {
  "@babel/helpers - typeof";
  return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, i(e);
}
function g(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function w(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, p(n.key), n);
  }
}
function x(e, t, r) {
  return t && w(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function P(e, t, r) {
  return t = u(t), j(e, l() ? Reflect.construct(t, r || [], u(e).constructor) : t.apply(e, r));
}
function j(e, t) {
  if (t && (i(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return A(e);
}
function A(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function l() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (l = function() {
    return !!e;
  })();
}
function u(e) {
  return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, u(e);
}
function S(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && f(e, t);
}
function f(e, t) {
  return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, f(e, t);
}
function s(e, t, r) {
  return t = p(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function p(e) {
  var t = T(e, "string");
  return i(t) == "symbol" ? t : t + "";
}
function T(e, t) {
  if (i(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (i(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function c() {
  return c = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, c.apply(this, arguments);
}
function E(e) {
  var t = e.xAxisId, r = h(), n = v(), o = d(t);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ a.createElement(O, c({}, o, {
      className: b("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(m) {
        return _(m, !0);
      }
    }))
  );
}
var y = /* @__PURE__ */ function(e) {
  function t() {
    return g(this, t), P(this, t, arguments);
  }
  return S(t, e), x(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ a.createElement(E, this.props);
    }
  }]);
}(a.Component);
s(y, "displayName", "XAxis");
s(y, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
export {
  y as XAxis
};
